// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__Cdu_1","label":"Radio_label__1ky5f","checkMark":"Radio_checkMark__2TLwy","disabled":"Radio_disabled__3Av2U"};